import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * State of the user in relation to the group
 */
export enum MemberState {
  IsMember = 'is_member',
  CanBeAdded = 'can_be_added',
  HasNoAccount = 'has_no_account',
}

/**
 * Container class for user group membership status
 *
 * @export
 * @class UserGroupMembershipStatus
 */
@JsonObject()
export class UserGroupMembershipStatus {
  @JsonProperty('Email') email: string;
  @JsonProperty('MemberState') memberState: MemberState;
}
